import { zoomStore, zoomStoreActions } from '../../../store';

export function onZoomWheel(delta: number) {
	const deltaStep = delta > 0 ? 0.1 : -0.1;

	const [minZoomLevel, maxZoomLevel] = zoomStore.zoomRanges.get();
	const currentZoomLevel = zoomStore.zoomLevel.get() || minZoomLevel;

	const newZoomLevel = currentZoomLevel - deltaStep;

	if (newZoomLevel > maxZoomLevel || newZoomLevel < minZoomLevel) {
		return;
	}

	zoomStoreActions.setZoomLevel(newZoomLevel);
}
